export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Logg på",
    "login.form.hint.user": "Pålogging",
    "login.form.hint.password": "Passord",
    "login.form.checkbox.remember-me": "Husk meg",
    "login.form.button.sign-in": "Logg på",
    "login.form.message.invalid-user-credentials": "Påloggingsnavn eller brukernavn er feil",
    "login.form.message.account-temporarily-locked": "Kontoen din er midlertidig låst. Kom tilbake om 5 minutter",
    "login.form.message.user-required": "Angi et påloggingsnavn",
    "login.form.message.password-required": "Angi et passord",
    "login.form.button.forgot-password": "Har du glemt passordet?",
    "error.mfa-required.title": "Konfigurer tofaktorautentisering",
    "error.mfa-required.message1": "Tofaktorautentisering (2FA) kreves for å beskytte kontoen din.",
    "error.mfa-required.message2": "Du blir omdirigert til kontoinnstillingene i det nettbaserte instrumentbordet. Aktiver 2FA, følg konfigurasjonsinstruksjonene, og kom deretter tilbake hit.",
    "error.mfa-required.learnMore": "Mer informasjon om 2FA",
    "error.mfa-required.continue": "Forsett",
    "error.root-admin-login.title": "Feil 403 – forbudt",
    "error.root-admin-login.message": "Du er logget inn som en skrivebeskyttet administrator. For å få tilgang til Web Recovery konsollen, logg inn som en kundeleier-bruker eller administrator i stedet",
    "error.server-busy.message": "Serveren er opptatt, prøv på nytt senere.",
    "error.network-connection.title": "Nettverkstilkoblingsfeil",
    "error.network-connection.message": "Kontroller Internett-tilkoblingen og prøv på nytt.",
    "error.internal-server-error.title": "Intern serverfeil",
    "error.internal-server-error.message": "Kontakt støtte med detaljer om feilen for å løse feilen:",
    "error.internal-server-error.copy.button": "Kopier"
};
